/* eslint-disable no-underscore-dangle */
import { useState, useEffect, useContext } from 'react';

import { useMutation } from '@apollo/client';

import { GeneralContext } from '../../../../../core/app-context/GeneralContext';
import { RESEND_RETURN_METHOD_EMAIL } from './graphql';

export function useResendReturnMethodSelection() {
  const { setLoading, setErrorMessage, setSuccessMessage } =
    useContext(GeneralContext);
  const [isLoading, setIsLoading] = useState(false);
  const [
    ResendReturnMethodSelection,
    { loading: apiLoading, error: apiError },
  ] = useMutation(RESEND_RETURN_METHOD_EMAIL);

  useEffect(() => {
    setErrorMessage(apiError);
  }, [apiError]);

  useEffect(() => {
    setIsLoading(apiLoading);
    setLoading(apiLoading);
  }, [apiLoading]);

  async function resendReturnMethodSelection({ orderId }) {
    try {
      const res = await ResendReturnMethodSelection({
        variables: { orderId },
      });
      if (res.data.resendReturnMethodEmail.code !== 200) {
        setErrorMessage(res.data.resendReturnMethodEmail.message);
      } else {
        setSuccessMessage(res.data.resendReturnMethodEmail.message);
      }
    } catch (e) {
      setErrorMessage(e.message);
    }
  }

  return {
    resendReturnMethodSelection,
    loading: isLoading,
  };
}
